
export const protoBaseFormField = [
  {
    label: '是否设置为默认分组',
    prop: 'isDefault',
    colNum: 24,
    slotName: 'isDefaultSlot'
  }
]
